import React from 'react';
import ReactDOM from 'react-dom';
import Lista from './Lista';
import axios from 'axios';
import apiurl from './apiurl';
import swal from 'sweetalert';
import NumberFormat from 'react-number-format';
import DodajBudZad from './DodajBudZad';
import update from 'immutability-helper';
import PrintComponents from 'react-print-components';
import ZaangazowaniePrint from './wydrukiBudzet/ZaangazowaniePrint';
import $ from 'jquery';



export default class BudzetZadaniowy extends React.Component {

constructor(props) {
  super();    
  this.state = {
    rok: props.rok,
    token: props.token,
    isLoading: true,
    isLoadingZagMod: false,
    listaWydz: [],
    dataTable: [],
    idWydz: '-1',
    dwbp: '2',
    opiniowanieData: [],
    opiniowanieValue: null,
    pasekSzukaj: false,
    pominZer: false,
  };

  // this.printTriggerRef = React.createRef();
}

componentDidMount() {
  this.getWydzialy();
  this.getData('2', '-1');

  //Szukanie
  this.getrodz();

  
}


getWydzialy = () => {
  this.setState({ loadingdata: true });
  let dataRow = this.props.dataRow;
  axios
    .get(apiurl+"api/Listy/GetWydzialy4ddl", { params : { rok: this.state.rok, idUchwal: dataRow.id }, headers: { 'Authorization' : "Bearer " + this.state.token }})
    .then(response => {
      if(response.data.length === 1) {
        this.setState({ listaWydz: response.data, idWydz: response.data[0].value })
      } else {
        this.setState({ listaWydz: response.data })
      }
    }
    )
    .catch(error => swal(error.response.data) );
}

getData = (dwbp, idWydz) => {
  let dataRow = this.props.dataRow;
  this.setState({ isLoading: true });
  axios
    .get(apiurl+"api/BudzetZad", { params: { rok: this.state.rok, idUchwaly: dataRow.id, idWydz: idWydz, dwbp: dwbp }, headers: { 'Authorization' : "Bearer " + this.state.token }})
    // .get(apiurl+"api/BudzetZad", { params: { rok: 2025, idUchwaly: 25, idWydz: 2, dwbp: 2 }, headers: { 'Authorization' : "Bearer " + this.state.token }})
    .then(response => {
      this.setState({ dataTable: response.data, isLoading: false })
    }
    )
    .catch(error => { swal(error.response.data); this.setState({ isLoading: false }) });
}

przejdzDodaj = () => { ReactDOM.render(<DodajBudZad
  token = {this.state.token}
  rok = {this.state.rok}
  dataRow={this.props.dataRow}
  />, document.getElementById("root")); }


czyUzasadnienie = () => {
  return this.state.dataTable.every(item => item.uwagiExist === true  || item.uwagiExist === "true");
}

printZang = () => {
  this.setState({ isLoadingZagMod: true });
  const idW = this.state.idWydz;
  const param = idW === '-1' ? { rok: this.state.rok, idUchwaly: this.props.dataRow.id } : { rok: this.state.rok, idUchwaly: this.props.dataRow.id, idWydzialu: idW }
  axios
    .get(apiurl+"api/BudzetZad/zaangazowanie", { 
      params : param, 
      headers: { 'Authorization' : "Bearer " + this.state.token }
    })
    .then(response => {
      // DRUKOWANIE PO ZAPYTANIU
      // this.setState({ dataPrintZang: response.data, isLoading: false }, () => {
      //   this.printTriggerRef.current.click();
      // });
      this.setState({ isLoadingZagMod: false, dataPrintZang: response.data });
    })
    .catch(error => swal(error.response.data) );
}


// FUNKCJE PRZEKOPIOWANE


zakonczEdycje = () => {
  if(this.state.idWydz === "-1") { swal("Wybierz wydział") }
  else{
    const listaWydz = this.state.listaWydz;
    const wydzial = listaWydz.find(item => item.value === this.state.idWydz)

    swal("Czy chcesz zamknąć edycję dla wydziału: " + wydzial.text  , {
      closeOnClickOutside: false,
      buttons: {
        cancel: "Anuluj",
        do: {
          text: "Zakończ edycje",
          value: "do",
        },
      },
    })
    .then((value) => {
      switch (value) {
        case "do":
          this.postZakonczEdycje();
          break;
      }
    });
  }
}

postZakonczEdycje = () => {
  axios.post(apiurl+"api/BudzetEdycja/ZamknijEdycje",
    {rok: this.state.rok, idUchwaly: this.props.dataRow.id, idWydzialu: this.state.idWydz },
    {headers : {'Content-Type': 'application/json' , 'Authorization' : "Bearer " + this.state.token } })
    .then(res => {
      swal(res.data);
    })
    .catch(error => swal(error.response.data));
}

ChangeWniosek = (wniosek, idx) => {
  var data = this.state.dataTable;

  var updatedComment = update(data[idx], {wniosek: {$set: wniosek}}); 
  var newData = update(data, {
    $splice: [[idx, 1, updatedComment]]
  });
  this.setState({ dataTable : newData });
}

opiniowanie() {

  axios
    .get(apiurl+"api/Opinie2/Opiniodawcy", { params: { rok: this.state.rok, idUchwaly: this.props.dataRow.id, idWydzialu: this.state.idWydz }, headers: { 'Authorization' : "Bearer " + this.state.token }})
    .then(response =>
      this.setState({ opiniowanieData: response.data })
    )
    .catch(error =>swal(error.response.data), this.setState({ isVisible3: true }));

}

postOpiniowanie = (e) => {
  e.preventDefault();
  const data = JSON.parse(this.state.opiniowanieValue);
  const dataNow = new Date();

  axios.post(apiurl+"api/Opinie2/Post1", {
    id: null,
    rok: Number(this.state.rok),
    idUchwaly: Number(this.props.dataRow.id),
    idWydzialu: Number(this.state.idWydz),
    idOpiniodawcyDo: data.idOpiniodawcy,
    kodOperDo: data.kodOper,
    dataOtw: dataNow,
    kodOper: null,
    idOpiniodawcy: null,
    uwagi: null,
    status: null,
    dataZamk: null,
    nazwaWydzialu: null,
    nazwaUchwaly: null,
  },
  {headers : {'Content-Type': 'application/json' , 'Authorization' : "Bearer " + this.state.token } })
  .then(res => {
    swal('Zapisano')
  })
  .catch(error => {
    // if(error.response.data === 2390) {
    //   swal({
    //     title: 'Nieprawidłowy status. Czy chcesz dla danego dokumentu ustawić status na: "W opiniowaniu"?',
    //     buttons: {
    //     cancel: "Anuluj",
    //     catch: {
    //       text: "Tak",
    //       value: "willDelete",} 
    //     },
    //     dangerMode: true,
    //   })
    //   .then((willDelete) => {
    //     if (willDelete) {
    //       axios
    //       .get(apiurl+"api/Opinie2/SetStatusDoOpiniowania", { params: { rok: this.state.rok, idUchwaly: this.state.id }, headers: { 'Authorization' : "Bearer " + this.state.token }})
    //       .then(response => {
    //         swal(response.data);
    //         this.postOpiniowanie(e)
    //       })
    //       .catch(error => swal(error.response.data));
    //     } else { return null }
    //   });
    // } else { 
    //   swal(error.response.data) 
    // }
      swal(error.response.data ? error.response.data : 'Błąd') 
  });
}

deleteOpiniowanie() {

  swal({
    title: 'Czy na pewno chcesz usunąć wszystkie opinie dla tego dokumentu?',
    buttons: {
    cancel: "Anuluj",
    catch: {
      text: "Tak",
      value: "willDelete",} 
    },
    dangerMode: true,
  })
  .then((willDelete) => {
    if (willDelete) {
      axios.delete(apiurl + "api/Opinie2/UsunOpinie", { params: { rok: this.state.rok, idUchwaly: this.props.dataRow.id }, headers: { 'Authorization' : "Bearer " + this.state.token } })
      .then(res => {
        swal(res.data);
      })
      .catch(error => swal(error.response.data))
    } else { return null }
  });

}

setDataUzasadnienie = (data) => {
  this.setState({ dataUzasadnienie: data, uzasadnienieTextArea: '' });
  this.getUzasadnienie(data);
}

getUzasadnienie = (data) => {
  axios.get(apiurl+"api/UwagiZadan", {params: {
    rok: data.rok,
    idUchwaly: data.idUchwaly,
    idWydzialu: data.idWydzialu,
    idRodz: data.idRodzaju,
    dwbp: this.state.dwbp,
    dzial: data.dzial,
    rozdzial: data.rozdzial,
    paragrafP4: data.paragrafP4,
    pozycja: data.pozycja,
    idDzialania: data.idDzialania,
    idZadania: data.idZadania,
  }, headers: { 'Authorization' : "Bearer " + this.props.token}})
  .then(response => {
    this.setState({ uzasadnienieTextArea: response.data })
  })
  .catch(error => { 
  console.log('Error get uzasadnienie')
  });
}

saveUzasadnienie  = (e) => {
  e.preventDefault();
  const dane = this.state.dataUzasadnienie;
  axios.post(apiurl+"api/UwagiZadan",
  {
    uwagi: this.state.uzasadnienieTextArea,
    rok: dane.rok,
    idUchwaly: dane.idUchwaly,
    idWydzialu: dane.idWydzialu,
    idRodz: dane.idRodzaju,
    dwbp: this.state.dwbp,
    dzial: dane.dzial,
    rozdzial: dane.rozdzial,
    paragrafP4: dane.paragrafP4,
    pozycja: dane.pozycja,
    idDzialania: dane.idDzialania,
    idZadania: dane.idZadania,
    wniosek: dane.wniosek,
  },
  {headers : {'Content-Type': 'application/json' , 'Authorization' : "Bearer " + this.state.token } })
  .then(res => {
    swal('Zapisano')
  })
  .catch(error => {
    swal(error.response.data ? error.response.data : 'Błąd')
  });
}

opiniowanieStatus() {
  this.setState({ loadingStatusyOpinii: true });
  axios
    .get(apiurl+"api/Opinie2/StatusyOp", { params: { rok: this.state.rok, idUchwaly: this.props.dataRow.id }, headers: { 'Authorization' : "Bearer " + this.state.token }})
    .then(response => this.setState({ opiniowanieStatusData: response.data, loadingStatusyOpinii: false }) )
    .catch(error =>swal(error.response.data), this.setState({ loadingStatusyOpinii: false }));
}

wroc = () => { ReactDOM.render(<Lista  token = {this.state.token} rok = {this.state.rok}/>, document.getElementById("root")); }

suma = (data, key) => {
  let total = 0;
  data.filter(item => 
    (!this.state.szudzial || item.dzial.toLowerCase().includes(this.state.szudzial)) &&
    (!this.state.szurozdzial || item.rozdzial.toLowerCase().includes(this.state.szurozdzial)) &&
    (!this.state.szuparagraf || String(item.paragraf + item.p4).toLowerCase().includes(this.state.szuparagraf)) &&
    (!this.state.szupozycja || item.pozycja.toLowerCase().includes(this.state.szupozycja)) &&
    (!this.state.szurodzaj || item.rodzajNazwa.toLowerCase().includes(this.state.szurodzaj.toLowerCase()))
  ).forEach((item, idx) => {
    let itemdot = item[key];
    let itemnum = parseFloat(itemdot);
    total += itemnum;
    total = parseFloat(total.toFixed(2));
  });
  return total;
};

//SZUKANIE FUNKCJE

getrodz = async () => {
  const res = await axios.get(apiurl+"api/Listy/GetSlownikRodzaje?", { params : {rok : this.state.rok }, headers: { 'Authorization' : "Bearer " + this.state.token }}).catch(error => this.setState({ error,  }));
  let datarodz = res.data.map( category => ({ rodzajvalue: category.value, nazwarodzaj: category.text}));
  this.setState({ datarodz });
}

_handleKeyDown = (e) => {
  if (e.key === 'Enter') {
    this.szukajka();
  }
}

// KONIEC FUNKCJE PRZEKOPIOWANE

//Informacja o zamknietej edycji wydzialu z ddl
onChangeWydział = (e) => {
  const values = this.state.listaWydz.filter(wydz => wydz.idWydzialu === Number(e.target.value));
  this.setState({ idWydz: e.target.value, czyEdycjaZamknieta: values[0]?.editable, dataTable: []})
  this.getData(this.state.dwbp,  e.target.value)
}

render() {
const { dataRow, konfig, wersjaTabeli } = this.props;
const { dwbp, listaWydz, idWydz, isLoading, dataTable, opiniowanieData, opiniowanieValue, opiniowanieStatusData, 
        uzasadnienieTextArea, dataPrintZang, isLoadingZagMod, szuRokR, szudzial, szurozdzial, szuparagraf, szupozycja, 
        szurodzaj, datarodz, pasekSzukaj, pominZer, czyEdycjaZamknieta } = this.state;
const ukryjPlan = konfig.ukryjPlan;
const czyOpinie = konfig.opinie;
const czyUzasadnienie = this.czyUzasadnienie();


return (<React.Fragment>
  <div class="container-fluid">
    <h2>Budżet zadaniowy- {dataRow.nazwa}</h2>
    <hr /> 

    <div style={{ width: "100%", overflowX: "auto" }}>
      <div className='d-flex flex-row w-75 mb-3' style={{ minWidth: "1250px" }}>
        
        <button class="btn btn-light m-1" onClick={() => this.wroc()}> Wróć </button>

        <select  type="select" class="form-control m-1" onChange={(e) => (this.setState({ dwbp: e.target.value }), this.getData(e.target.value, this.state.idWydz))} name="dwbpSelect" value={dwbp}>
          <option key="1" defaultValue="Wybierz" hidden="hidden" >Wybierz</option>
          {/* <option key="2" value="1" >Dochody budżetowe</option>
          <option key="3" value="2" >Wydatki budżetowe</option> */}
          <option key="2" value="1" >Dochody</option>
          <option key="3" value="2" >Wydatki</option>
          <option key="4" value="3" >Dochody pozabudżetowe</option>
          <option key="5" value="4" >Wydatki pozabudżetowe</option>
          <option key="6" value="5" >Przychody</option>
          <option key="7" value="6" >Rozchody</option>
        </select>

        <select type="select" class="form-control m-1" onChange={(e) => (this.onChangeWydział(e))} value={idWydz}>
          {listaWydz && listaWydz.length === 1 ? null : (<option key="-1" value="-1">Wszystkie wydziały</option>)}
          {listaWydz.map((values, idx) => {
              return (
                <option key={idx} value={values.idWydzialu}>{values.nazwa}</option>
              );
              })}
        </select>  

        {czyOpinie && <button type="button" class="btn btn-light text-nowrap m-1"  data-toggle="modal" data-target="#opinieStatusyModal" onClick={() => (this.opiniowanieStatus())}> Statusy opinii </button>}

        <button class="btn btn-light m-1" onClick={() => (this.przejdzDodaj())}> Dodaj </button>

        <button class="btn btn-light m-1" onClick={() => this.getData(this.state.dwbp, this.state.idWydz)}> Odśwież </button>

        <button class={czyUzasadnienie ? "btn btn-light text-nowrap m-1" : "btn btn-danger text-nowrap m-1"} onClick={() => (this.zakonczEdycje())}> Zakończ edycję </button>

        {czyOpinie && <>
          {idWydz !== '-1' ? (<button type="button" class="btn btn-light text-nowrap m-1" onClick={() => this.opiniowanie()} data-toggle="modal" data-target="#opiniowanieModal"> Prześlij do opiniowania</button>) : (<button type="button" class="btn btn-light text-nowrap m-1" disabled> Prześlij do opiniowania </button>)}
        </>}

        <button class="btn btn-light text-nowrap m-1" data-toggle="modal" data-target="#zaangazowanieModal" onClick={() => this.printZang()}>Pokaż zaangażowanie</button>
        
        <i class="fas fa-search szukajka align-self-center ml-2"  onClick={() => (this.setState(prevState => ({ pasekSzukaj: !prevState.pasekSzukaj, szudzial : '' , szurozdzial : '' , szuparagraf : '' , szupozycja : '' , szurodzaj : '' })))}></i>
      
      </div>
    </div>

    {/* Szukanie */}
    {pasekSzukaj && <div className='d-flex flex-column' style={{ width: "100%", overflowX: "auto" }}>
      <div className="d-flex flex-row mb-4 " >
        <span className="align-self-center ml-2">Szukaj: </span>

        <input type="text" name="szuRokR" className="form-control w-auto ml-1" placeholder="Rok realizacji" value={szuRokR} onChange={(e) => (this.setState({ [e.target.name]: e.target.value }))} onKeyDown={this._handleKeyDown}></input>

        <input type="text" name="szudzial" className="form-control w-auto ml-1" placeholder="Dział" value={szudzial} onChange={(e) => (this.setState({ [e.target.name]: e.target.value }))} onKeyDown={this._handleKeyDown}></input>

        <input type="text" name="szurozdzial" className="form-control  w-auto ml-1" placeholder="Rozdział" value={szurozdzial} onChange={(e) => (this.setState({ [e.target.name]: e.target.value }))} onKeyDown={this._handleKeyDown}></input>

        <input type="text" name="szuparagraf" className="form-control  w-auto ml-1" placeholder="Paragraf" value={szuparagraf} onChange={(e) => (this.setState({ [e.target.name]: e.target.value }))} onKeyDown={this._handleKeyDown}></input>

        <input type="text" name="szupozycja" className="form-control  w-auto ml-1" placeholder="Pozycja" value={szupozycja} onChange={(e) => (this.setState({ [e.target.name]: e.target.value }))} onKeyDown={this._handleKeyDown}></input>

        <select type="select" class="form-control w-auto ml-1" name="szurodzaj" value={szurodzaj} onClick={() => (this.setState(prevState => ({ pasekSzukaj: !prevState.pasekSzukaj })))}>
          <option key="-1" value="">Wszystkie rodzaje</option>
          {datarodz?.map(data => {
          const { nazwarodzaj } = data;
          return (
            <option value={nazwarodzaj} > {nazwarodzaj}</option>
          );
          })}
        </select>

        <div class="form-group form-check ml-2 mr-2 d-flex flex-row pointer" onChange={() => (this.setState(prevState => ({ pominZer: !prevState.pominZer })))}>
          <input type="checkbox" class="form-check-input" id="pominZerowe" checked={pominZer} ></input>
          <label class="form-check-label text-nowrap" for="pominZerowe">Pomiń stany zerowe</label>
        </div>

        <button type="button" className="btn btn-light ml-1 text-nowrap" onClick={() => (this.setState({ szudzial: '' , szurozdzial: '' , szuparagraf: '' , szupozycja: '' , szurodzaj: '' }))}>Resetuj filtry</button>

      </div>
    </div>}
    
    {isLoading && <center><div class="spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div></center>}

    {(!czyEdycjaZamknieta && dataTable.length > 0 && idWydz !== '-1') && <div class="alert alert-warning" role="alert">Edycja dla tego wydziału jest zamknięta.</div>}

    <div class="table-responsive card" style={{ maxHeight: '70vh', overflowY: 'auto', overflowX: 'auto', position: 'relative' }}>
      <table id="budzetZad" class="table table-hover" style={{ minWidth: "1600px" }}>   
        <thead className='bg-light sticky-top top-0'>
          <tr>
            <th class="text-left" width="5%">Rok realizacji</th>
            <th class="text-left" width="5%">Zadanie</th>
            <th class="text-left" width="5%">Dział</th>
            <th class="text-left" width="5%">Rozdział</th>
            <th class="text-left" width="5%">Paragraf</th>
            <th class="text-left" width="5%">Pozycja</th>
            <th class="text-left" width="5%">Rodzaj</th>
            <th class="text-left" width="5%">Wydział</th>
            <th class="text-left" width="20%">Opis</th>
            {!wersjaTabeli ? (<th class="text-right" width="5%"><b>Plan ubiegłoroczny</b></th>) : (<th class="text-right" width="5%"><b>Przed</b></th>)}
            {wersjaTabeli && <th class="text-right" width="5%">Po</th>}
            {wersjaTabeli ? null : ukryjPlan ? null : <th class="text-right" width="5%">Po Wniosku</th>}
            {ukryjPlan ? null : !wersjaTabeli ? (<th class="text-right" width="5%"><b>Plan</b></th>) : (<th class="text-right" width="5%"><b>Zmiany</b></th>)}    
            <th class="text-right" width="5%">Plan w locie</th>
            <th class="text-right" width="5%">Wniosek</th>
            <th class="text-center">{szudzial}</th>
          </tr>
        </thead>
        <tbody>
            {dataTable.length > 0 ? (<>
              {dataTable.filter(item => 
                (!szuRokR || String(item.rok_r).toLowerCase().includes(szuRokR)) &&
                (!szudzial || item.dzial.toLowerCase().includes(szudzial)) &&
                (!szurozdzial || item.rozdzial.toLowerCase().includes(szurozdzial)) &&
                (!szuparagraf || String(item.paragraf + item.p4).toLowerCase().includes(szuparagraf)) &&
                (!szupozycja || item.pozycja.toLowerCase().includes(szupozycja)) &&
                (!szurodzaj || item.rodzajNazwa.toLowerCase().includes(szurodzaj.toLowerCase()))
              ).filter(val => !pominZer || val.wniosek !== 0).map((dane, idx) => {
                return <TableRow 
                  token={this.state.token}
                  dane={dane} 
                  idx={idx}
                  ChangeWniosek={this.ChangeWniosek}
                  setDataUzasadnienie={this.setDataUzasadnienie}
                  ukryjPlan={ukryjPlan}
                  wersjaTabeli={wersjaTabeli}
                  dwbp={dwbp}
                  dataRowLista={dataRow}
                />
              })}
              <tr>
                <td colSpan={9} className='text-right'>SUMA</td>
                <td className='text-right' ><NumberFormat value={this.suma(dataTable, 'przed')} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} /></td>
                {wersjaTabeli && <td className='text-right' ><NumberFormat value={this.suma(dataTable, 'po')} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} /></td>}
                {wersjaTabeli ? null : ukryjPlan ? null : <td className='text-right' ><NumberFormat value={this.suma(dataTable, 'poWniosku')} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} /></td>}
                {!ukryjPlan && <td className='text-right' ><NumberFormat value={this.suma(dataTable, 'zmiany')} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} /></td>}
                <td className='text-right' ><NumberFormat value={this.suma(dataTable, 'sumaLot')} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} /></td>
                <td className='text-right' ><NumberFormat value={this.suma(dataTable, 'wniosek')} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} /></td>
              </tr> 
            </>) : (!isLoading && <tr><td colSpan={13} className='text-center'>Brak danych</td></tr>)}
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal" tabindex="-1" role="dialog" id="opiniowanieModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Opiniowanie</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body m-3">
          {/* {opiniowanieData ? (<><select class="form-control p-2" id="selectOpiniowanie"  onChange={(e) => (this.setState({ opiniowanieValue: e.target.value}))}><option disabled selected hidden>Wybierz</option>{opiniowanieData.map((data, idx) => { const value = JSON.stringify(data); const opiniowal = data.czyOpiniowal ? "T" : "N"; return (<>{data.pomin === 'N' ? (<option key={idx} value={value}>{data.nazwaOpiniodawcy}, Operator: {data.nazwaOperatora}, Opiniował: {opiniowal}</option>) : null }</>) } )}</select></>) : (<div className='d-flex flex-row justify-content-center w-100'><div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div></div>) } */}
          {opiniowanieData ? (<><select class="form-control p-2" id="selectOpiniowanie"  onChange={(e) => (this.setState({ opiniowanieValue: e.target.value}))}><option disabled selected hidden>Wybierz</option>{opiniowanieData.map((data, idx) => { const value = JSON.stringify(data); return (<>{data.pomin === 'N' ? (<option key={idx} value={value}>{data.nazwaOpiniodawcy}, {data.czyOpiniowal}</option>) : null }</>) } )}</select></>) : (<div className='d-flex flex-row justify-content-center w-100'><div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div></div>) }
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger mr-auto" onClick={(e) => (this.deleteOpiniowanie(e))}>Usuń</button>
          {opiniowanieValue ? (<button type="button" class="btn btn-primary" onClick={(e) => (this.postOpiniowanie(e))}>Zapisz</button>) : (<button type="button" class="btn btn-primary" disabled>Zapisz</button>)}
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Zamknij</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal" tabindex="-1" role="dialog" id="opinieStatusyModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Opiniowanie statusy</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body m-3">
        <table className='table table-striped'>
          <thead>
              <tr>
                <th>Opiniodawca</th>
                <th>Nazwa wydziału</th>
                <th>Opis</th>
                <th>Status</th>
              </tr>
          </thead>
          <tbody>
          {this.state.loadingStatusyOpinii && <div className='d-flex flex-row justify-content-center w-100'><div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div></div>} 
          
          {opiniowanieStatusData && opiniowanieStatusData.length > 0 ? (<>{opiniowanieStatusData.map((data, idx) => {
            const uwagishort = data.uwagi.substring(0,10);
            const uwagiFull = this.state;
            return (<tr key={idx}>
                <td>{data.opiniodawca}</td>
                <td>{data.nazwaWydz}</td>
                <td >{data.uwagi.length > 10 ? (<>{uwagiFull ? (<span>{data.uwagi}</span>) : (<span>{uwagishort}...</span>)}</>) : (<span>{data.uwagi}</span>)}</td>
                <td>{data.status}</td>
            </tr>)
          })}</>) : (<td colSpan={4}><p className='text-center'>Brak danych</p></td>)}
          </tbody>
        </table>
        </div>
      </div>
    </div>
  </div>

  <div class="modal" tabindex="-1" role="dialog" id="uzasadnienieZadania">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Uzasadnienie do zadania</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body m-3">
          <textarea className='form-control' value={uzasadnienieTextArea} onChange={(e) => (this.setState({ uzasadnienieTextArea: e.target.value }))}></textarea>
        </div>
        <div class="modal-footer">
          {uzasadnienieTextArea !== '' ? (<button type="button" class="btn btn-primary" onClick={(e) => (this.saveUzasadnienie(e))}>Zapisz</button>) : (<button type="button" class="btn btn-primary" disabled>Zapisz</button>)}
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Zamknij</button>  
        </div>
      </div>
    </div>
  </div>

  {/* DRUKOWANIE PO ZAPYTANIU ZAANGAZOWANIE
  <div style={{ display: 'none' }}>
    <PrintComponents trigger={<button ref={this.printTriggerRef}>Drukuj</button>} >
      <ZaangazowaniePrint data={this.state.dataPrintZang} />
    </PrintComponents>
  </div> */}

  <div class="modal" id="zaangazowanieModal">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header d-flex">
          <h5 class="modal-title">Zaangażowanie</h5>
          <div className='d-flex ml-auto'>
            <PrintComponents trigger={<button className='btn btn-light btn-sm mt-1 mr-1' disabled={!dataPrintZang || dataPrintZang?.length === 0}>Drukuj</button>} >
              <ZaangazowaniePrint data={this.state.dataPrintZang} />
            </PrintComponents>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <div class="modal-body">
          {isLoadingZagMod && <center><div class="spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div></center>}
          {dataPrintZang && <ZaangazowaniePrint data={dataPrintZang} />}
        </div>
      </div>
    </div>
  </div>

</React.Fragment>);

}

}


export class TableRow extends React.Component {


editWniosek = () => {
  const dane = this.props.dane;
  var numericWniosek = parseFloat(this.props.dane.wniosek.replace(',', '.'));

  axios.put(apiurl+"api/Zadania", {
      rok: dane.rok, 
      idUchwaly: dane.idUchwaly, 
      idWydzialu: dane.idWydzialu, 
      idRodz: dane.idRodzaju,
      dwbp: this.props.dwbp,
      dzial: dane.dzial, 
      rozdzial: dane.rozdzial, 
      paragrafP4 : dane.paragrafP4, 
      pozycja: dane.pozycja, 
      idDzialania: dane.idDzialania, 
      idZadania: dane.idZadania, 
      wniosek: numericWniosek, 
    }, {headers : {'Content-Type': 'application/json' , 'Authorization' : "Bearer " + this.props.token} })
    .then(res => {
      swal(res.data);
      this.props.ChangeWniosek(numericWniosek, this.props.idx)
     })
    .catch(error => { swal(error.response.data); });
}

onChangeWniosek = (e, przed) => {
  const status = this.props.dataRowLista.status;
  const value = Number(String(e.target.value).replace(",", ".").trim());


    const wynik = Number(String(przed).replace(",", ".").trim()) + value;

    if(wynik < 0) {
      swal('Kwota niepoprawna');
    } else { 
      this.props.ChangeWniosek(e.target.value, this.props.idx)
    }
  // }
}
  

render() {

const { idx, dane, wersjaTabeli, ukryjPlan, dataRowLista } = this.props;

return (<>
  <tr key={idx}>
    <td>{dane.rok_r}</td>
    <td>{dane.zadanie}</td>
    <td>{dane.dzial}</td>
    <td>{dane.rozdzial}</td>
    <td>{dane.paragrafP4}</td>
    <td>{dane.pozycja}</td>
    <td>{dane.rodzajNazwa}</td>
    <td>{dane.wydzialKod}</td>
    <td>{dane.opis}</td>
    <td className='text-right'><NumberFormat value={dane.przed} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} /></td>
    {wersjaTabeli && <td className='text-right'><NumberFormat value={dane.po} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} /></td>}
    {wersjaTabeli ? null : ukryjPlan ? null : <td className='text-right'><NumberFormat value={dane.poWniosku} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} /></td>}
    {!ukryjPlan && <td className='text-right'><NumberFormat value={dane.zmiany} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} /></td>}
    <td className='text-right'><NumberFormat value={dane.sumaLot} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} /></td>
    <td className='text-right'><NumberFormat value={dane.wniosek} size={dane.wniosek.length} class="input text-right" id={idx} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} onChange={(e) => (this.onChangeWniosek(e, dane.przed))} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} /></td>
    <td className='d-flex flex-row'>
      <button type="button" onClick={() => (this.editWniosek())} className="btn btn-light btn-sm">Zapisz</button>
      {dane.uwagiExist ? <button type="button" className="btn btn-light btn-sm ml-1" data-toggle="modal" data-target="#uzasadnienieZadania" onClick={() => (this.props.setDataUzasadnienie(dane))}>Uzasadnienie</button> : <button type="button" className="btn btn-danger btn-sm ml-1" data-toggle="modal" data-target="#uzasadnienieZadania" onClick={() => (this.props.setDataUzasadnienie(dane))}>Uzasadnienie</button>}
    </td>
  </tr>
</>);
}

}



